<template>
    <div>
        <table class="m-table ta-left" v-if="list && list.length">                            
            <tr v-for="(item,index) in list" :key="index">
                <td width="10%" class="ta-center"><span :class="rankClass(index)">{{index>2?(index+1):''}}</span></td>
                <td class="pd-2">
                    <router-link :to="{name:'others',query:{uid:item.userInfo['uid']}}">
                    <k-user :logo="item.userInfo.logo.thumb50" :nick="item.userInfo.nick"></k-user>
                    </router-link>
                </td>
                <td width="15%" class="ta-center cl-gray">
                    <span v-if="type===4">{{(item.transDate||'').slice(8,10) || ''}}日</span>
                    <!--<span v-else>上周</span>-->
                </td>
                <td width="25%" class="ta-right cl-red"><k-num :value="flagValue(item)" /><span :class="numUnit"></span></td>
            </tr>
        </table>
        <p v-else><k-no-data></k-no-data></p>
    </div>
</template>
<script>
    export default {
        props : {
            list : {
                type : Array,
                default : null
            },
            type: {
                type : Number,
                default : 4
            }
        },
        computed: {
            numUnit(){
                return this.type?'icon-gold':''
            }
        },
        methods: {
            rankClass(index){
                return index < 3 ? ('sort-' + index) : ''
            },

            dataText(item){
                if(this.type === 4 && item){
                    return (item['ctime'] || '').slice(8,10);
                } else {
                    return '上周'
                }
            },

            flagValue(item){
               let R = {
                   3 : item.totalIncome,
                   4 : item.totalIncome,
                   0 : item.wTotalUnbrokenWin,
               }
                return R[this.type]
            },
        },
    }
</script>